import SubmitTechnicalChallengeModal from './SubmitTechnicalChallengeModal.container';

export default SubmitTechnicalChallengeModal;
